<div class="user-grid-wrapper w-full h-full flex flex-column">
  <div class="p-0 flex-1 overflow-y-auto overflow-x-hidden">
    <!-- Skeleton grid: aparece só no carregamento inicial -->
    <p-dataView *ngIf="isLoading && items.length === 0" [value]="skeletonItems" [paginator]="false" [rows]="20"
      layout="grid">
      <ng-template let-skel pTemplate="gridItem">
        <div class="ss-l-video-container-widget item">
          <p-skeleton width="100%" height="100%" styleClass="w-full h-full border-round"></p-skeleton>
        </div>
      </ng-template>
    </p-dataView>

    <!-- Grid real -->
    <p-dataView *ngIf="!isLoading && items.length > 0" [value]="items" [paginator]="false" [rows]="24" layout="grid">
      <ng-template let-item let-i="index" pTemplate="gridItem">
        <div class="ss-l-video-container-widget item cursor-pointer" (click)="onItemClick(item)">
          <img [src]="item.thumbnail" alt="" />
        </div>
      </ng-template>
    </p-dataView>
  </div>
</div>